module.exports = __webpack_public_path__ + "img/instacafe.173a05af.svg";